import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';
import { AttributesComponent } from './attributes.component';
import { ZoningCodeAttributesPopupComponent } from './attributes-popup/zoning-code-attributes-popup.component';
import { AttributesStatisticCollectionNames } from 'src/shared/enums';
import { IAttributePopupEntityParams } from 'src/app/interfaces/attribute-popup-params.interface';

@Component({
    standalone: false,
    selector: 'zoning-code-attributes',
    templateUrl: './attributes.component.html',
    styleUrls: ['./attributes.component.scss']

})
export class ZoningCodeAttributesComponent extends AttributesComponent implements OnInit {
    ngOnInit() {
        super.ngOnInit();
        this.entityName = AttributesStatisticCollectionNames.ZONING_CODE_ATTRIBUTES_STATISTICS;
        this.popupComponent = ZoningCodeAttributesPopupComponent;
    }

    getParameters(): IAttributePopupEntityParams {
        return {
            TableType: this.tableType,
            TableFieldId: this.tableFieldId,
            ZoningCodeId: this.selectedZoningCode && this.selectedZoningCode.Id,
        };
    }

}
